<div class="cash-dialog">
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon class="header-icon">point_of_sale</mat-icon>
      <div>
        <h2 mat-dialog-title class="title-text">Clôture de la caisse (Z)</h2>
        <span class="subtitle-text">{{ recap.station_name }}</span>
      </div>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" [disabled]="sending" aria-label="Fermer" class="btn-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="z-layout">
      <section class="z-recap">
        <div class="z-title">Encaissé par mode</div>
        <table class="breakdown z-methods">
          <thead><tr><th>Mode</th><th class="num">Nombre</th><th class="num">Montant</th></tr></thead>
          <tbody>
            @for (m of methods; track m.method) {
              <tr><td>{{ m.name ?? 'Mode ' + m.method }}</td><td class="num">{{ m.count }}</td><td class="num" [class.neg]="m.amount < 0">{{ m.amount | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</td></tr>
            } @empty {
              <tr><td colspan="3" class="empty">Aucun règlement encaissé à ce poste</td></tr>
            }
            <tr class="total"><td>Total</td><td class="num">{{ count }}</td><td class="num" [class.neg]="recap.total < 0">{{ recap.total | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</td></tr>
          </tbody>
        </table>
        <div class="z-title z-title-cash">Espèces de la caisse</div>
        <table class="breakdown z-cash">
          <tbody>
            <tr><td>Fond du matin</td>
              @if (recap.opening_float_found) {
                <td class="num">{{ recap.opening_float | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</td>
              } @else {
                <td class="num"><span class="unknown">inconnu</span><span class="note"> ({{ recap.opening_float | currency:'EUR':'symbol':'1.2-2':'fr-FR' }} retenu)</span></td>
              }
            </tr>
            <tr><td>+ Espèces encaissées</td><td class="num" [class.neg]="recap.cash_payments < 0">{{ recap.cash_payments | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</td></tr>
            <tr><td>+ Reçu</td><td class="num">{{ recap.transfers_in | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</td></tr>
            <tr><td>− Versé au coffre</td><td class="num">{{ recap.transfers_out | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</td></tr>
            <tr class="total"><td>Espèces attendues</td><td class="num" [class.neg]="recap.expected_cash < 0">{{ recap.expected_cash | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</td></tr>
          </tbody>
        </table>
      </section>

      <form [formGroup]="form" (ngSubmit)="confirm()" id="zCloseForm" class="z-panels">
        <section class="z-panel z-panel-drop">
          <div class="z-title">Versement au coffre</div>
          @if (safe) {
            <app-cash-count-grid #dropGrid idPrefix="z-drop-count" caption="Versement au coffre" [decimalComma]="true" [disabled]="sending || lost" (changed)="onCount('drop', $event)" (lastEnter)="countedGrid?.focusFirst()" />
          } @else if (data.balanceError) {
            <div class="msg msg-error no-safe"><mat-icon>block</mat-icon><span>Coffre-fort du magasin illisible ({{ data.balanceError }}) : clôture sans versement.</span></div>
          } @else {
            <div class="msg msg-error no-safe"><mat-icon>block</mat-icon><span>Aucun coffre-fort actif dans ce magasin : clôture sans versement.</span></div>
          }
          <mat-form-field appearance="outline" class="amount-field z-amount">
            <mat-label>Versement au coffre</mat-label>
            <input matInput appCents type="number" step="0.01" min="0" formControlName="drop" id="z-drop" autocomplete="off" (focus)="$any($event.target).select()" />
            <span matTextSuffix>&nbsp;€</span>
            @if (dropCtl.hasError('amountCap')) {
              <mat-error>Au plus 999 999 999,99 €</mat-error>
            } @else if (dropCtl.hasError('required')) {
              <mat-error>Comptez ou saisissez le montant versé (0 si rien)</mat-error>
            } @else if (dropCtl.invalid) {
              <mat-error>Montant positif ou nul, deux décimales au plus</mat-error>
            }
          </mat-form-field>
          @if (differs(dropGrid, drop)) {
            <div class="note z-differs">Saisi à la main : différent du comptage ({{ dropGrid!.total | currency:'EUR':'symbol':'1.2-2':'fr-FR' }})</div>
          }
          @if (safe) {
            <div class="note z-hint">Vers <b>{{ safe.name }}</b> — fond de caisse à l'ouverture : {{ recap.opening_float_found ? (recap.opening_float | currency:'EUR':'symbol':'1.2-2':'fr-FR') : 'inconnu' }}</div>
          }
        </section>

        <section class="z-panel">
          <div class="z-title">Fond de caisse compté <span class="note">reste en caisse</span></div>
          <app-cash-count-grid #countedGrid idPrefix="z-counted-count" caption="Fond de caisse compté" [decimalComma]="true" [disabled]="sending || lost" (changed)="onCount('counted', $event)" (lastEnter)="focusSubmit()" />
          <mat-form-field appearance="outline" class="amount-field z-amount">
            <mat-label>Fond de caisse compté</mat-label>
            <input matInput appCents type="number" step="0.01" min="0" formControlName="counted" id="z-counted" autocomplete="off" required (focus)="$any($event.target).select()" />
            <span matTextSuffix>&nbsp;€</span>
            @if (countedCtl.hasError('amountCap')) {
              <mat-error>Au plus 999 999 999,99 €</mat-error>
            } @else if (countedCtl.hasError('nonNegativeCents')) {
              <mat-error>Montant positif ou nul, deux décimales au plus</mat-error>
            } @else if (countedCtl.hasError('required')) {
              <mat-error>Comptez ce qui reste en caisse (0 si vide)</mat-error>
            }
          </mat-form-field>
          @if (differs(countedGrid, counted)) {
            <div class="note z-differs">Saisi à la main : différent du comptage ({{ countedGrid!.total | currency:'EUR':'symbol':'1.2-2':'fr-FR' }})</div>
          }
          @if (expected !== null) {
            <div class="note z-hint" id="z-expected">attendu : <span class="num" [class.neg]="expected < 0">{{ expected | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</span></div>
          }
        </section>
      </form>
    </div>

    @if (gap !== null) {
      <div class="z-gap" id="z-gap" [class.neg]="gap !== 0">Écart : <span class="num">{{ gap | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</span>
        @if (gap < 0) { <span class="note"> (manque)</span> } @else if (gap > 0) { <span class="note"> (excédent)</span> }
      </div>
      <!-- Écart côté gauche : compté − attendu, l'égalité est exacte au centime. -->
      <p class="z-identity" id="z-identity">
        Fond du matin {{ recap.opening_float_found ? '' : '(inconnu) ' }}{{ recap.opening_float | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
        + Espèces encaissées {{ recap.cash_payments | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
        + Reçu {{ recap.transfers_in | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
        + Écart <span [class.neg]="gap !== 0">{{ gap | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</span>
        = <b>Fond du soir {{ counted | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</b>
        + Versé au coffre {{ totalOut | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
      </p>
    } @else if (counted !== null) {
      <div class="note" id="z-gap-hint">Saisissez le versement au coffre (0 si rien) : l'écart s'affiche ici.</div>
    } @else {
      <div class="note" id="z-gap-hint">Comptez le fond de caisse : l'écart s'affiche ici.</div>
    }

    @if (dropped > 0) {
      <div class="msg msg-ok" id="z-dropped">
        <mat-icon>check_circle</mat-icon>
        <span>Versement de {{ dropped | currency:'EUR':'symbol':'1.2-2':'fr-FR' }} déjà enregistré au coffre : ne le refaites pas.</span>
      </div>
    }
    @if (sendError) {
      <div class="msg msg-error" id="z-error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ sendError }}</span>
      </div>
    }
    <div class="msg msg-warn">
      <mat-icon>warning_amber</mat-icon>
      <span>{{ warning }}</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button type="button" (click)="cancel()" [disabled]="sending">Annuler</button>
    <button mat-flat-button color="warn" type="submit" form="zCloseForm" [disabled]="!canConfirm" class="btn-submit" id="z-submit">
      <mat-icon>lock</mat-icon>
      <span>{{ (drop ?? 0) > 0 ? 'Verser et clôturer (Z)' : 'Clôturer (Z)' }}</span>
    </button>
  </mat-dialog-actions>
</div>
